import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { del, get, set } from "idb-keyval";

// The app's data cache, saved in IndexedDB so the last-seen data shows offline and after a
// reload. Changes waiting to sync are stored separately (see src/sync/store.ts).
export const persister = createAsyncStoragePersister({
  key: "ct.queries",
  storage: {
    getItem: async (key) => (await get<string>(key).catch(() => undefined)) ?? null,
    setItem: (key, value: string) => set(key, value).catch(() => undefined),
    removeItem: (key) => del(key).catch(() => undefined),
  },
  throttleTime: 1000,
});

export const CACHE_MAX_AGE_MS = 14 * 24 * 60 * 60 * 1000;
